"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPropsFromDecorators = void 0;
const getPropsFromDecorators = (decorators = [], payload, canAction) => {
    const result = {};
    decorators.some((curr) => {
        const { disabled, hidden } = curr(payload || {}, { canAction });
        if (payload && payload.loading) {
            result.disabled = true;
        }
        else {
            result.disabled = result.disabled || disabled;
        }
        result.hidden = result.hidden || hidden;
        if (result.hidden) {
            return true;
        }
        return;
    });
    return result;
};
exports.getPropsFromDecorators = getPropsFromDecorators;
//# sourceMappingURL=getPropsFromDecorators.js.map